<template>
  <v-icon color="white">mdi-information</v-icon>
</template>
<script setup></script>
<style scoped></style>
